import React from "react";

export const VideoTabs = ({ activeTab, onTabChange, activeCount, completedCount }) => (
  <div className="flex gap-1 mb-4" data-testid="video-tabs">
    <button
      onClick={() => onTabChange("active")}
      className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
        activeTab === "active" ? "bg-white/10 text-white" : "text-gray-400 hover:text-white"
      }`}
      data-testid="tab-active"
    >
      Active ({activeCount})
    </button>
    <button
      onClick={() => onTabChange("completed")}
      className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors ${
        activeTab === "completed" ? "bg-white/10 text-white" : "text-gray-400 hover:text-white"
      }`}
      data-testid="tab-completed"
    >
      Completed ({completedCount})
    </button>
  </div>
);
